export default "__VITE_ASSET__D_I9jH6d__"